module.exports = __webpack_public_path__ + "dashboard/img/right.8eb105081ba47db3082a34f3e9fefff8.svg";